import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Table = styled.table`
  width: 100%;
  border-top: 1px solid ${props => props.theme.palette.general.greyLight};

  th {
    text-align: left;
    font: ${font('default', 'normal', '15px/1')};
    color: ${props => props.theme.palette.general.greyDark};
    padding: 15px 15px 15px 0;
    border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};
  }

  td {
    text-align: right;
    font: ${font('default', 'normal', '15px/1')};
    color: ${props => props.theme.palette.general.strong};
    padding: 15px 0 15px 15px;
    border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};
  }

  tr {
    &:last-child {
      th {
        font: ${font('default', 'bold', '17px/1')};
        color: ${props => props.theme.palette.general.strong};
        padding-top: 20px;
        padding-bottom: 20px;
      }

      td {
        font: ${font('default', 'bold', '17px/1')};
        color: ${props => props.theme.palette.general.strong};
        padding-top: 20px;
        padding-bottom: 20px;
      }
    }
  }

  .tax-row {
    cursor: pointer;

    span {
      position: relative;
    }

    svg {
      position: absolute;
      top: 50%;
      right: -12px;
      transform: translateY(-50%) rotate(0deg);
      transform-origin: 50% 50%;
      transition: transform 300ms ease;
      width: 7px;
      height: 7px;
      fill: ${props => props.theme.palette.general.grey};
    }

    &--visible {
      svg {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }
`
